import React, { useEffect, useState } from "react";
import { initialsFromDisplayName, resolveAvatarDisplayName } from "@/utils/avatarInitials.js";

/**
 * @param {{
 *   displayName?: string,
 *   prenom?: string,
 *   nom?: string,
 *   photoUrl?: string|null,
 *   size?: 'sm'|'md'|'lg',
 *   className?: string,
 *   testId?: string,
 * }} props
 */
export function PersonAvatar({
  displayName,
  prenom,
  nom,
  photoUrl = null,
  size = "md",
  className = "",
  testId = "person-avatar",
}) {
  const name = resolveAvatarDisplayName({ displayName, prenom, nom });
  const initials = initialsFromDisplayName(name);
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [photoUrl]);

  const hasPhoto = Boolean(photoUrl && String(photoUrl).trim()) && !imgFailed;

  return (
    <div
      className={`karate-person-avatar karate-person-avatar--${size}${className ? ` ${className}` : ""}`}
      data-testid={testId}
      data-photo-active={hasPhoto ? "true" : "false"}
    >
      <div className="karate-person-avatar__ring" role="img" aria-label={name || "Personne"}>
        {hasPhoto ? (
          <img
            key={photoUrl}
            src={photoUrl}
            alt=""
            className="karate-person-avatar__img"
            decoding="async"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span className="karate-person-avatar__initials" aria-hidden="true">
            {initials}
          </span>
        )}
      </div>
    </div>
  );
}
